import axios from 'axios'
import qs from 'qs'
import * as Raven from 'raven-js'
import ravenSendData from '@/raven-send-data'
import config from '@/config'

// const debug = process.env.NODE_ENV !== 'production'
const debug = false

const http = axios.create({
  baseURL: `${config.SERVER_URL}/api`
})

http.interceptors.request.use(request => {
  if (toString.call(request.data) === '[object Object]') {
    request.data = qs.stringify(request.data)
  }

  if (debug) {
    // リクエストログの出力
    console.log(`${request.method.toUpperCase()} ${request.url} >> ${JSON.stringify(request.data)}`)
  }
  return request
})

http.interceptors.response.use(
  response => {
    if (typeof response.data === 'string') {
      return Promise.reject(response.data)
    }
    if (debug) {
      // レスポンスログの出力
      console.log(' << ', JSON.stringify(response.data))
    }
    return Promise.resolve(response)
  },
  error => {
    Raven.setTagsContext(ravenSendData.tagsContext)
    Raven.setUserContext(ravenSendData.userContext)
    Raven.captureException(error)
    console.error(error)
    return Promise.reject(error)
  }
)

export default http
